import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import { ReactComponent as MarkerIcon } from './assets/icons/marker.svg';

const NavigatorTargetMarker = () => {
  return (
    <div className={styles.navigatorTargetMarker}>
      <MarkerIcon className={styles.navigatorTargetMarkerPin} />
      <CroplerIcon name="camera" className={styles.navigatorTargetMarkerIcon} />
    </div>
  );
}

export default NavigatorTargetMarker;